import { IGetDraftJobPostResult } from '../types';
import { DraftJobPostAdapters } from '../adapters';
import { PermanentJobsApi } from '../clients';

export const getDraftJobPost = async (id: string): Promise<IGetDraftJobPostResult> => {
  const response = await PermanentJobsApi.getJobPostDetail(id);

  return DraftJobPostAdapters.toGetDraftJobPostResult(response);
};
